import * as Sentry from '@sentry/react';
import { Box, EmptyState } from '@shopify/polaris';
import PagePickupBird from 'layouts/page/PagePickupBird';
import React from 'react';
import { transformToCdnUrl } from 'utils/google-storage-util';
import { useNavigate, useRouteError } from 'react-router';

const ServerErrorPage: React.FC = (props) => {
    const navigate = useNavigate();
    const error = useRouteError() as Error;

    const handleRetry = () => {
        navigate('/');
    };

    React.useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <PagePickupBird hideFooter>
            <Box paddingBlockStart={'1200'}>
                <EmptyState
                    heading={'Server error!'}
                    action={{
                        content: 'Click here to retry',
                        onAction: () => handleRetry(),
                    }}
                    image={transformToCdnUrl('embedded-assets/404_illustration.webp')}
                >
                    <p>An error occurred while retrieving your data, please try again later</p>
                </EmptyState>
            </Box>
        </PagePickupBird>
    );
};

export default ServerErrorPage;
